module.exports = __webpack_public_path__ + "img/khal_img01.6be3cdf7.svg";